import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";

//import withRouter
import withRouter from "../../Common/withRouter";

//i18n
import { withTranslation } from "react-i18next";

//redux
import { Link } from "react-router-dom";
import { createSelector } from "reselect";
import { RootState } from "../../../slices/store";
import { useSelector, useDispatch } from "react-redux";
import { setAgency } from "src/slices/Auth/Agency/thunk";
import { loginSuccess } from "src/slices/Auth/Login/reducer";
import {
  setSelectedAgency,
  setSelectedOrder,
  setSelectedLineItems,
  setStartDate,
  setEndDate,
} from "../../../slices/Filters/reducer";
const ProfileMenu = (props: any) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const selectLeadData = createSelector(
    (state: any) => state.profile.success,
    (leadsChart) => leadsChart
  );
  // Inside your component
  const success = useSelector(selectLeadData);

  // Declare a new state variable, which we'll call "menu"
  const [menu, setMenu] = useState<boolean>(false);

  const [email, setemail] = useState<string>("");
  const [username, setusername] = useState<string>("");
  const [avatar, setavatar] = useState<string>("");
  const [usertype, setusertype] = useState<string>("");
  const profile = useSelector((state: RootState) => state.profile);
  const userState = useSelector((state: RootState) => state.login);
  const agencyState = useSelector((state: RootState) => state.agency);
  const authUser: any = localStorage.getItem("authUser");
  const adminUser: any = localStorage.getItem("adminUser");
  const tempAuthUser: any = localStorage.getItem("tempAuthUser");
  const { user } = useSelector((state: any)  => state.login);
  const obj = userState.user.user;
  const agencyData = useSelector((state: any) => state.agency.agency.data);

  useEffect(() => {
    // const getAuthUser = localStorage.getItem("authUser");
    if (obj) {
      if (obj.name) {
        setusername(obj.name);
        setemail(obj.email);
        if(obj.profile_picture_url)
          setavatar(obj.profile_picture_url);
        else
           setavatar("");
       
        setusertype(obj.user_type);
      } else {
        setusername(obj.name);
      }
    }
  }, [success, profile, agencyState, user, userState]);

  const handleAdminLogin = () => {
    if (adminUser) {
      // Set authUser immediately
      localStorage.setItem("authUser", adminUser);
      const userObj = JSON.parse(adminUser);
      
      // Clear all filters first
      if(usertype != 'Client')
        dispatch(setSelectedAgency(''));
      dispatch(setSelectedOrder(''));
      dispatch(setSelectedLineItems(''));
      dispatch(setStartDate(''));
      dispatch(setEndDate(''));
      
      // Login success dispatch
      dispatch(loginSuccess(userObj));
      
      // Clean up localStorage
      localStorage.removeItem("adminUser");
      localStorage.removeItem("tempAuthUser");
      localStorage.removeItem('alert_shown');
      
      // Final agency dispatch
      dispatch(setAgency({ agency_id: null }, navigate, true));
    }
  };

  const handleAgencyAdminLogin = () => {
    if (tempAuthUser) {
      // Set authUser immediately
      localStorage.setItem("authUser", tempAuthUser);
      const userObj = JSON.parse(tempAuthUser);
      
      // Clear all filters first
      if(usertype != 'Client')
        dispatch(setSelectedAgency(''));
      dispatch(setSelectedOrder(''));
      dispatch(setSelectedLineItems(''));
      dispatch(setStartDate(''));
      dispatch(setEndDate(''));
      
      // Login success dispatch
      dispatch(loginSuccess(userObj));
      
      // Clean up localStorage
      localStorage.removeItem("tempAuthUser");
      localStorage.removeItem('alert_shown');
      
      // Final agency dispatch
      dispatch(setAgency({ agency_id: agencyData.Id }, navigate, true));
    }
  };
const getInitials = (name: string) => {
    if (!name) return '';
    const words = name.trim().split(' ').filter(Boolean);
    const firstInitial = words[0]?.charAt(0).toUpperCase() || '';
    const secondInitial = words.length > 1 ? words[1]?.charAt(0).toUpperCase() : '';
    return firstInitial + secondInitial;
  };

  return (
    <React.Fragment>
      <Dropdown
        isOpen={menu}
        toggle={() => setMenu(!menu)}
        className="d-inline-block profilejoy"
      >
       <DropdownToggle
          className="btn header-item user d-flex align-items-center text-start p-0 border-0 bg-transparent"
          id="page-header-user-dropdown"
          tag="button"
          style={{ width: 'auto', minWidth: 0 }}
        >
          <div className="d-flex align-items-center">
          {avatar ? (
            <img
              className="rounded-circle header-profile-user"
              src={avatar}
              alt="Header Avatar"
              style={{ width: 33, height: 33, objectFit: "cover",flexShrink: 0,  }}
            />
          ) : (
            <div
              className="rounded-circle text-white d-flex align-items-center justify-content-center"
              style={{ width: 33, height: 33, fontWeight: "bold", fontSize: 14, backgroundColor: "#607d8b" ,flexShrink: 0, }}
            >
              {getInitials(obj.name)}
            </div>
          )}
          {/* This will be hidden on small screens */}
          <div className="ms-2 d-none d-md-flex flex-column" style={{ minWidth: 0,flexGrow:1 }}>
            <span className="user-name"   style={{
          whiteSpace: "nowrap",
          fontSize:"13px",
        }}>
              {username}
            </span>
            <span className="user-sub-title" style={{ maxWidth: 150, textTransform:"capitalize" }}>
              {usertype}
            </span>
          </div>
          </div>
        </DropdownToggle>
        <DropdownMenu className="dropdown-menu-end pt-0" end>
          <div className="p-3 bg-primary border-bottom">
            <h6 className="mb-0 text-white">{username}</h6>
            <p 
              className="mb-0 font-size-11 text-white-50 fw-semibold text-truncate"
              style={{ 
                maxWidth: '200px'
              }}
            >
              {email}
            </p>
          </div>
          {usertype == "Client" && (
            <DropdownItem 
              className="profile-dropdown"
              onClick={() => navigate("/profile")}
            >
              <i className="mdi mdi-account-circle text-muted font-size-16 align-middle me-1"></i>{" "}
              <span className="align-middle">
                <Link to="/profile"> {props.t("Profile")}</Link>
              </span>
            </DropdownItem>
          )}
          {(usertype !== "admin" && adminUser) && (
            <DropdownItem onClick={handleAdminLogin} className="profile-dropdown">
              <i className="mdi mdi-logout text-muted font-size-16 align-middle me-1"></i>{" "}
              <span className="align-middle">
                <Link to="#">{props.t("Admin Login")}</Link>
              </span>
            </DropdownItem>
          )}
          {(usertype !== "admin" && tempAuthUser) && (
            <DropdownItem onClick={handleAgencyAdminLogin} className="profile-dropdown">
              <i className="mdi mdi-logout text-muted font-size-16 align-middle me-1"></i>{" "}
              <span className="align-middle">
                <Link to="#">{props.t("Agency Admin Login")}</Link>
              </span>
            </DropdownItem>
          )}
          <DropdownItem 
            className="profile-dropdown"
            onClick={() => navigate("/logout")}
            >
            <i className="mdi mdi-logout text-muted font-size-16 align-middle me-1"></i>{" "}
            <span className="align-middle">
              <Link to="/logout">{props.t("Logout")}</Link>
            </span>
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>
    </React.Fragment>
  );
};

export default withTranslation()(withRouter(ProfileMenu));
